var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBookmarkStroke = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6667 5V16.6651C16.6667 16.9807 16.4884 17.2693 16.2061 17.4104C15.9238 17.5516 15.586 17.5212 15.3335 17.3319L10 13.3333L4.66658 17.3319C4.41405 17.5212 4.07624 17.5516 3.79396 17.4104C3.51168 17.2693 3.33337 16.9807 3.33337 16.6651V5C3.33337 3.61929 4.45266 2.5 5.83337 2.5H14.1667C15.5474 2.5 16.6667 3.61929 16.6667 5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBookmarkStroke);
export default ForwardRef;